import React, { Component, Fragment } from "react";
import {
  showNotification, Filter, TextInput, SimpleForm, List, Edit, Query,
  Create, Datagrid, SelectInput, FormTab, EditButton, DateField, FunctionField,
  NumberField, Button, Link, Toolbar, TextField, Pagination, SaveButton,
  ReferenceInput, AutocompleteInput, ReferenceField, ReferenceManyField,
  NumberInput, DateInput, LongTextInput, FormDataConsumer, TabbedForm
} from 'react-admin';
import { GenericInputFilter } from '../components/selectboxfilter/genericInputFilter';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { parse } from "query-string";
import dataProviderFactory from '../dataProvider'
import { GET_LIST, UPDATE } from 'react-admin'
import ForwardIcon from "@material-ui/icons/Forward";
import { isNil, head, filter, path, propEq, prop, sum, map } from 'ramda'
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { required } from "ra-core";
import IconCancel from "@material-ui/icons/Cancel";
import { change, submit, isSubmitting } from "redux-form";
import { connect } from "react-redux";

const chargeTypes = [
  { _id: '1', description: 'Stripe' },
  { _id: '2', description: 'Other (Money, bank transfer)' },
];

class RefundButtonDamage extends Component {
  state = {
    visible: true,
    error: false,
    showDialog: false,
    isOnSubmit: false,
    chargeValue: 0,
    maxReturnValue: 0,
    chargeComments: "",
    internalComments: "",
  };

  handleValueChange = (element) => {
    this.setState({ [element.target.id]: element.target.value });
  };

  handleValueChangeBool = (element) => {
    this.setState({ [element.target.id]: element.target.checked });
  };

  componentDidMount() {
    const { record } = this.props;

    const charges = record;
    const paymentRegister = record.payment;
    //console.log(record)
    const totalRefunded = record.refunded_value

    //const hasCancelnsurance = !isEmpty(rental.cancel_insurance);
    const totalPayed = paymentRegister.value - totalRefunded;

    this.setState({
      maxReturnValue: totalPayed,
      chargeValue: totalPayed,
      isSubmitting: false,
    });
  }

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleChangeItem = (element, type) => {
    this.setState({ [type]: element.target.value });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false, isSubmitting: false });
  };

  handleSaveClick = () => {
    const { submit } = this.props;
    this.setState({ isOnSubmit: true }, () => {
      submit("charge-send");
    });
  };

  handleSubmit = async () => {
    const { record, rentalId, reloadData, history } = this.props;
    //const bodyRequest = { id: record.id, data: 
    //{ status: 2 } };
    const bodyRequest = {
      id: this.props.record.id,
      data: {
        partial: 1,
        status: 2,
        value: this.state.chargeValue,
        comments: this.state.chargeComments,
        internalComments: this.state.internalComments,
      },
    };
    const dataProvider = await dataProviderFactory("rest");
    //console.log(history.id)

    // this.setState({ visible: false });

    dataProvider(UPDATE, "charges", bodyRequest)
      .then(response => {
        //console.log(response);
        //reloadData(rentalId);
        showNotification("Charge refunded with success");
        this.setState({
          showDialog: false,
          chargeValue: 0,
          isOnSubmit: false,
          chargeComments: "",
          internalComments: "",
        });
        if (!isNil(history)) {
          const link = `/vehicle_damages/${history.id}`;

          history.history.replace(link);
        }
      })
      .catch(error => {
        console.error(error);
        showNotification(error.message, "error");
      });
  };

  render() {
    const { record } = this.props;
    //const rental = head(path(["payment", "rentals"], record));
    const { showDialog, isOnSubmit } = this.state;

    if (this.state.visible) {
      return (
        /* <Button label="Refund" onClick={this.handleClick}>
          <ForwardIcon />
        </Button> */
        <Fragment>
          <Button label="Refund Charge" onClick={this.handleClick}>
            <ForwardIcon titleAccess="Refund Charge" cursor="pointer" />
          </Button>
          <Dialog
            fullWidth={true}
            maxWidth={"md"}
            open={showDialog}
            onClose={this.handleCloseClick}
            aria-label="Refund Charge"
          >
            <DialogTitle>
              Refund Charge - Damage
              <br />
            </DialogTitle>
            <DialogContent>
              <SimpleForm
                form="charge-send"
                resource="charges"
                onSubmit={this.handleSubmit}
                toolbar={null}
                destroyOnUnmount={true}
              >
                <TextInput
                  source="chargeValue"
                  label={`Value (Eur max) ${this.state.maxReturnValue}`}
                  type="number"
                  //defaultValue={this.state.chargeValue}
                  onChange={this.handleValueChange}
                  validate={required()}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                {this.props.record.old_invoice && (
                  <FunctionField
                    label="Old Invoice Number"
                    render={() => {
                      return this.props.record.old_invoice;
                    }}
                  />
                )}
                <LongTextInput
                  source="chargeComments"
                  label="Comments"
                  type="text"
                  onChange={this.handleValueChange}
                  validate={required()}
                  defaultValue={this.state.chargeComments}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <LongTextInput
                  source="internalComments"
                  label="IMT Comments"
                  type="text"
                  onChange={this.handleValueChange}
                  validate={required()}
                  defaultValue={this.state.internalComments}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </SimpleForm>
            </DialogContent>
            <DialogActions>
              {" "}
              <SaveButton
                saving={isOnSubmit}
                onClick={this.handleSaveClick}
                disabled={
                  parseFloat(this.state.chargeValue) >
                  Math.abs(record.value - record.refunded_value).toFixed(2) ||
                  isOnSubmit ||
                  this.state.chargeComments === "" ||
                  this.state.chargeValue <= 0
                }
              />
              <Button label="ra.action.cancel" onClick={this.handleCloseClick}>
                <IconCancel />
              </Button>
            </DialogActions>
          </Dialog>
        </Fragment>
      );
    }
    return "";
  }
}
const mapStateToProps = (state) => ({
  isSubmitting: isSubmitting("charge-send")(state),
});

const mapDispatchToProps = {
  change,
  showNotification,
  submit,
};

export default connect(mapStateToProps, mapDispatchToProps)(RefundButtonDamage);



// WEBPACK FOOTER //
// ./src/components/RefundButtonDamage.js